import * as React from 'react';
import { Routes, Navigate, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import AuthLayoutRoute from "@/app/auth/layout/AuthLayoutRoute";
import DashboardLayoutRoute from "@/app/layout/DashboardLayoutRoute";
import MasterLayoutRoute from "@/app/layout/MasterLayoutRoute";
import EventFullScreenLayoutRoute from "@/app/layout/EventFullScreenLayoutRoute";
import OrganizerLayout from "@/app/layout/OrganizerLayout";
import Dashboard from "@/app/event/Dashboard";
import Events from "@/app/event/Events";
import asyncComponent from '../AsyncComponent';
import WaitingListOrders from "../app/components/app/event_site/billing/items/WaitingListOrders";
import { EventService } from "services/event/event-service";
import { getFirstAvailableSubMenuRoute, isGetMenuAliasAllowed, getCachedMenuHierarchy, resolveMenuHierarchy } from "../app/utils/navigationUtils";

const Login = asyncComponent(() =>
  import('@/app/auth/Login').then(module => module.default)
)

const EventModuleOrder = asyncComponent(() =>
  import('@/app/settings/EventModuleOrder').then(module => module.default)
)

const EventSiteModuleOrder = asyncComponent(() =>
  import('@/app/settings/EventSiteModuleOrder').then(module => module.default)
)

const AttendeeWidget = asyncComponent(() =>
  import('@/app/attendee/AttendeeWidget').then(module => module.default)
)
const AttendeeImportLogs = asyncComponent(() =>
  import('@/app/attendee/ImportLogs').then(module => module.default)
)
const AttendeeImportLogDetail = asyncComponent(() =>
  import('@/app/attendee/ImportLogDetail').then(module => module.default)
)

const EventDocument = asyncComponent(() =>
  import('@/app/documents/EventDocument').then(module => module.default)
)

const ResetPasswordRequest = asyncComponent(() =>
  import('@/app/auth/ResetPasswordRequest').then(module => module.default)
)

const UpdatePasswordRequest = asyncComponent(() =>
  import('@/app/auth/UpdatePasswordRequest').then(module => module.default)
)
const Last_2FA_Request = asyncComponent(() =>
  import('@/app/auth/Last_2FA_Request').then(module => module.default)
)
const ResetPassword = asyncComponent(() =>
  import('@/app/auth/ResetPassword').then(module => module.default)
)

const OrganizerEmailHistory = asyncComponent(() =>
  import('@/app/organizer/OrganizerEmailHistory').then(module => module.default)
)

const Branding = asyncComponent(() =>
  import('@/app/settings/Branding').then(module => module.default)
)

const CustomSections = asyncComponent(() =>
  import('@/app/settings/CustomSections').then(module => module.default)
)

const EventsiteBanners = asyncComponent(() =>
  import('@/app/settings/EventsiteBanner').then(module => module.default)
)

const Sections = asyncComponent(() =>
  import('@/app/settings/Sections').then(module => module.default)
)
const WebsiteSections = asyncComponent(() =>
  import('@/app/settings/WebsiteSections').then(module => module.default)
)

const WebsiteSectionDetail = asyncComponent(() =>
  import('@/app/settings/WebsiteSectionDetail').then(module => module.default)
)
const Setting = asyncComponent(() =>
  import('@/app/header_footer/Setting').then(module => module.default)
)

const OpeningHour = asyncComponent(() =>
  import('@/app/header_footer/OpeningHour').then(module => module.default)
)

const ContactPerson = asyncComponent(() =>
  import('@/app/header_footer/ContactPerson').then(module => module.default)
)

const PageCrashed = asyncComponent(() =>
  import('@/PageCrashed').then(module => module.default)
)
const AssignEvent = asyncComponent(() =>
  import('@/app/event/components/AssignEvent').then(module => module.default)
)

const EventWrapper = asyncComponent(() =>
  import('@/app/event/EventWrapper').then(module => module.default)
)

const HotelManagement = asyncComponent(() =>
  import('@/app/hotel/HotelManagement').then(module => module.default)
)

const Survey = asyncComponent(() =>
  import('@/app/survey/Survey').then(module => module.default)
)

const SurveyQuestion = asyncComponent(() =>
  import('@/app/survey/SurveyQuestion').then(module => module.default)
)
const SurveyLeaderBoard = asyncComponent(() =>
  import('@/app/survey/SurveyLeaderBoard').then(module => module.default)
)
const SurveyLeaderBoardOuter = asyncComponent(() =>
  import('@/app/survey/SurveyLeaderBoardOuter').then(module => module.default)
)

const SurveyGroup = asyncComponent(() =>
  import('@/app/survey/SurveyGroup').then(module => module.default)
)

const SurveyQuestionFullScreenProjector = asyncComponent(() =>
  import('@/app/survey/SurveyQuestionFullScreenProjector').then(module => module.default)
)

const TemplateEditor = asyncComponent(() =>
  import('@/app/templates/TemplateEditor').then(module => module.default)
)

const ViewTemplateHistory = asyncComponent(() =>
  import('@/app/templates/ViewTemplateHistory').then(module => module.default)
)

const TemplateLogs = asyncComponent(() =>
  import('@/app/templates/Logs').then(module => module.default)
)

const AppPreview = asyncComponent(() =>
  import('@/app/AppPreview').then(module => module.default)
)

const ProgramWidget = asyncComponent(() =>
  import('@/app/program/ProgramWidget').then(module => module.default)
)
const AssignProgramSpeaker = asyncComponent(() =>
  import('@/app/program/AssignProgramSpeaker').then(module => module.default)
)

const SpeakerWidget = asyncComponent(() =>
  import('@/app/speaker/SpeakerWidget').then(module => module.default)
)

const TeamsWidget = asyncComponent(() =>
  import('@/app/team/TeamsWidget').then(module => module.default)
)

const RegistrationInvitation = asyncComponent(() =>
  import('@/app/attendee/RegistrationInvitation').then(module => module.default)
)
const AppInvitation = asyncComponent(() =>
  import('@/app/attendee/AppInvitation').then(module => module.default)
)

const AppInvitationNotSent = asyncComponent(() =>
  import('@/app/attendee/AppInvitationNotSent').then(module => module.default)
)

const CustomExport = asyncComponent(() =>
  import('@/app/event_site/billing/CustomExport').then(module => module.default)
)

const NotRegisteredAttendees = asyncComponent(() =>
  import('@/app/attendee/NotRegisteredAttendees').then(module => module.default)
)

const NotAttendeesList = asyncComponent(() =>
  import('@/app/attendee/NotAttendeesList').then(module => module.default)
)

const RegistrationInvitationReminderLog = asyncComponent(() =>
  import('@/app/attendee/RegistrationInvitationReminderLog').then(module => module.default)
)

const AppInvitationReminderLog = asyncComponent(() =>
  import('@/app/attendee/AppInvitationReminderLog').then(module => module.default)
)

const RegistrationInvitationSetting = asyncComponent(() =>
  import('@/app/attendee/RegistrationInvitationSetting').then(module => module.default)
)

const InvitationProcess = asyncComponent(() =>
  import('@/app/attendee/InvitationProcess').then(module => module.default)
)
const RegistrationInvitesProcess = asyncComponent(() =>
  import('@/app/attendee/RegistrationInvitesProcess').then(module => module.default)
)
const RegistrationInvitesImportLogs = asyncComponent(() =>
  import('@/app/attendee/RegistrationInvitesImportLogs').then(module => module.default)
)
const RegistrationInvitesImportLogDetail = asyncComponent(() =>
  import('@/app/attendee/RegistrationInvitesImportLogDetail').then(module => module.default)
)

const InvitationBatchStatus = asyncComponent(() =>
  import('@/app/attendee/InvitationBatchStatus').then(module => module.default)
)

const PracticalInformation = asyncComponent(() =>
  import('@/app/event-information/PracticalInformation').then(module => module.default)
)

const AdditionalInformation = asyncComponent(() =>
  import('@/app/event-information/AdditionalInformation').then(module => module.default)
)

const InformationPages = asyncComponent(() =>
  import('@/app/event-information/InformationPages').then(module => module.default)
)

const GeneralInformation = asyncComponent(() =>
  import('@/app/event-information/GeneralInformation').then(module => module.default)
)

const SubRegistration = asyncComponent(() =>
  import('@/app/sub-registration/SubRegistration').then(module => module.default)
)

const SubRegistrationResults = asyncComponent(() =>
  import('@/app/sub-registration/SubRegistrationResults').then(module => module.default)
)

const SubRegistrationAttendeeEdit = asyncComponent(() =>
  import('@/app/sub-registration/SubRegistrationAttendeeEdit').then(module => module.default)
)

const Gdprcontainer = asyncComponent(() =>
  import('@/app/Gdprcontainer').then(module => module.default)
)

const AttendeeGdprLog = asyncComponent(() =>
  import('@/app/registration/AttendeeGdprLog').then(module => module.default)
)

const Disclaimer = asyncComponent(() =>
  import('@/app/Disclaimer').then(module => module.default)
)

const GoogleMap = asyncComponent(() =>
  import('@/app/GoogleMap').then(module => module.default)
)

const CompanyDetails = asyncComponent(() =>
  import('@/app/registration-form/CompanyDetails').then(module => module.default)
)

const AttendeeType = asyncComponent(() =>
  import('@/app/registration-form/AttendeeType').then(module => module.default)
)

const CustomFields = asyncComponent(() =>
  import('@/app/registration-form/custom-fields/CustomFieldsListing').then(module => module.default)
)

const CreateRegistrationForm = asyncComponent(() =>
  import('@/app/registration-form/CreateRegistrationForm').then(module => module.default)
)
const PrivateAddressForm = asyncComponent(() =>
  import('@/app/registration-form/PrivateAddressForm').then(module => module.default)
)

const NewsWidget = asyncComponent(() =>
  import('@/app/news/NewsWidget').then(module => module.default)
)

const EventsiteNewsWidget = asyncComponent(() =>
  import('@/app/eventsite-news/EventsiteNewsWidget').then(module => module.default)
)

const ReportWidget = asyncComponent(() =>
  import('@/app/reports/ReportWidget').then(module => module.default)
)

const PaymentProvider = asyncComponent(() =>
  import('@/app/event_site/billing/PaymentProvider').then(module => module.default)
)

const PaymentMethod = asyncComponent(() =>
  import('@/app/event_site/billing/PaymentMethod').then(module => module.default)
)

const EANInvoiceSetting = asyncComponent(() =>
  import('@/app/event_site/billing/EANInvoiceSetting').then(module => module.default)
)

const FIKSetting = asyncComponent(() =>
  import('@/app/event_site/billing/FIKSetting').then(module => module.default)
)

const BillingItem = asyncComponent(() =>
  import('@/app/event_site/billing/items/BillingItem').then(module => module.default)
)

const Voucher = asyncComponent(() =>
  import('@/app/event_site/billing/voucher/Voucher').then(module => module.default)
)

const Order = asyncComponent(() =>
  import('@/app/event_site/billing/order/Order').then(module => module.default)
)

const OrderSummary = asyncComponent(() =>
  import('@/app/event_site/billing/order/OrderSummary').then(module => module.default)
)

const PurchasePolicy = asyncComponent(() =>
  import('@/app/event_site/billing/PurchasePolicy').then(module => module.default)
)

const Profile = asyncComponent(() =>
  import('@/app/organizer/Profile').then(module => module.default)
)

const Password = asyncComponent(() =>
  import('@/app/organizer/Password').then(module => module.default)
)

const RegistrationStatistics = asyncComponent(() =>
  import('@/app/event_site/billing/registration_form/statsdashboard').then(module => module.default)
)

const eventInfo = localStorage.getItem('eventInfo');

class RouterOutlet extends React.Component {

  state = {
    event: (eventInfo && eventInfo !== undefined ? JSON.parse(eventInfo) : {}),
    localStorageVersion: Date.now(), // Add version counter for localStorage changes
    menuHierarchy: getCachedMenuHierarchy(),
    menuHierarchyLoaded: getCachedMenuHierarchy().length > 0,
  };

  static getDerivedStateFromProps(props, state) {
    const raw = localStorage.getItem('eventInfo');
    if (!raw) return state.event && Object.keys(state.event).length ? { event: {} } : null;
  
    try {
      const parsed = JSON.parse(raw);
      if (parsed?.id !== state.event?.id) {
        return { event: parsed };
      }
    } catch (e) {
      return null;
    }
    return null;
  }

  componentDidMount() {
    // Listen for localStorage changes
    window.addEventListener('storage', this.handleStorageChange);
    // Also check for localStorage changes periodically
    this.localStorageCheckInterval = setInterval(this.handleStorageChange, 1000);
    this.loadMenuHierarchy();
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
    if (this.localStorageCheckInterval) {
      clearInterval(this.localStorageCheckInterval);
    }
  }

  handleStorageChange = () => {
    const eventId = localStorage.getItem('event_id');
    if (eventId && eventId !== this.loadedMenuEventId) {
      this.loadMenuHierarchy();
      return;
    }
  
    const cached = getCachedMenuHierarchy();
    this.setState(prevState => {
      const menuChanged = JSON.stringify(cached) !== JSON.stringify(prevState.menuHierarchy);
      if (!menuChanged) {
        return null; // no update → no re-render
      }
      return {
        localStorageVersion: Date.now(),
        menuHierarchy: cached,
        menuHierarchyLoaded: true,
      };
    });
  };

  loadMenuHierarchy = () => {
    const eventId = localStorage.getItem('event_id');
    if (!eventId) {
      return;
    }

    this.loadedMenuEventId = eventId;
    const cached = getCachedMenuHierarchy();
    if (cached.length > 0 && !this.state.menuHierarchyLoaded) {
      this.setState({
        menuHierarchy: cached,
        menuHierarchyLoaded: true,
      });
    }

    EventService.getMenuHierarchy(eventId).then(
      (response) => {
        if (eventId !== this.loadedMenuEventId) {
          return;
        }
        if (response.success) {
          localStorage.setItem(`menuHierarchy_${eventId}`, JSON.stringify(response.data));
          this.setState({
            menuHierarchy: response.data,
            menuHierarchyLoaded: true,
          });
        } else {
          this.setState({ menuHierarchyLoaded: true });
        }
      },
      () => {
        if (eventId !== this.loadedMenuEventId) {
          return;
        }
        this.setState({ menuHierarchyLoaded: true });
      }
    );
  }

  /**
   * Gate routes by get-menu status (not module_permissions).
   * status 1 → allow page, status 0 → redirect away.
   */
  menuRoute = (aliases, page, parentAlias = 'upload_content') => {
    if (window.location.pathname.includes('/event/create')) {
      return page;
    }

    // Always evaluate against freshest get-menu cache (sidebar updates it first)
    const hierarchy = resolveMenuHierarchy(this.state.menuHierarchy);

    if (isGetMenuAliasAllowed(hierarchy, aliases)) {
      return page;
    }

    // Wait for first load if no cache yet — do not flash a blocked page open
    if (!this.state.menuHierarchyLoaded && hierarchy.length === 0) {
      return null;
    }

    const fallback =
      getFirstAvailableSubMenuRoute(parentAlias, hierarchy) ||
      '/event/preview';

    if (fallback === window.location.pathname) {
      return <Navigate to="/event/preview" replace />;
    }

    return <Navigate to={fallback} replace />;
  }

  render() {
    const { auth } = this.props;
    // Check both Redux state and localStorage for authentication
    const localStorageAuth = localStorage.getItem('eventBuizz');
    const reduxAuth = auth && Object.keys(auth).length > 0;
    const isAuthenticated = reduxAuth || (localStorageAuth && localStorageAuth !== 'undefined' && localStorageAuth !== '{}');

    return (
      <div>
        {!isAuthenticated ? (
          <Routes>
            {/*Auth Routes*/}
            <Route path="/login" element={<AuthLayoutRoute><Login /></AuthLayoutRoute>} />
            <Route path="/autoLogin/:token?" element={<AuthLayoutRoute><Login /></AuthLayoutRoute>} />
            <Route path="/reset-password-request" element={<AuthLayoutRoute><ResetPasswordRequest /></AuthLayoutRoute>} />
            <Route path="/reset-password" element={<AuthLayoutRoute><ResetPassword /></AuthLayoutRoute>} />
            <Route path="/update-password" element={<AuthLayoutRoute><UpdatePasswordRequest /></AuthLayoutRoute>} />
            <Route path="/last-2fa-request" element={<AuthLayoutRoute><Last_2FA_Request /></AuthLayoutRoute>} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        ) : (
            <Routes>
              {/*Auth Routes*/}
              <Route path="/autoLogin/:token?" element={<AuthLayoutRoute><Login /></AuthLayoutRoute>} />
              {/*Dashboard Routes*/}
              <Route path="/" element={<DashboardLayoutRoute><Events /></DashboardLayoutRoute>} />
              <Route path="/dashboard" element={<EventFullScreenLayoutRoute><Dashboard /></EventFullScreenLayoutRoute>} />
              <Route path="/error" element={<DashboardLayoutRoute><PageCrashed /></DashboardLayoutRoute>} />

              {/*Admin Routes*/}
              <Route path="/admin/assign-events/:id" element={<OrganizerLayout><AssignEvent /></OrganizerLayout>} />

              {/*Event creation Routes*/}
              <Route path="/event/create" element={<MasterLayoutRoute><EventWrapper /></MasterLayoutRoute>} />
              <Route path="/event/settings/branding" element={<MasterLayoutRoute><Branding /></MasterLayoutRoute>} />
              <Route path="/event/settings/eventsite-banners" element={<MasterLayoutRoute><EventsiteBanners /></MasterLayoutRoute>} />
              <Route path="/event/settings/website-sections" element={<MasterLayoutRoute><WebsiteSections /></MasterLayoutRoute>} />
              <Route path="/event/settings/custom-sections" element={<MasterLayoutRoute><CustomSections /></MasterLayoutRoute>} />
              <Route path="/event/settings/website-sections/:sectionId" element={<MasterLayoutRoute><WebsiteSectionDetail /></MasterLayoutRoute>} />
              <Route path="/event/settings/registration-setting" element={<MasterLayoutRoute><Setting /></MasterLayoutRoute>} />
              <Route path="/event/settings/opening-hour" element={<MasterLayoutRoute><OpeningHour /></MasterLayoutRoute>} />
              <Route path="/event/settings/contact-person" element={<MasterLayoutRoute><ContactPerson /></MasterLayoutRoute>} />
              <Route path="/event/edit/:id" element={<MasterLayoutRoute><EventWrapper /></MasterLayoutRoute>} />
              <Route path="/event/settings/sections" element={<MasterLayoutRoute><Sections /></MasterLayoutRoute>} />

              {/*Event Registration form Routes*/}
              <Route path="/event/registration/basic-detail-form" element={this.menuRoute(['attendee_fields'], <MasterLayoutRoute><CreateRegistrationForm /></MasterLayoutRoute>, 'online_registration_form')} />
              <Route path="/event/registration/company-detail-form" element={this.menuRoute(['company_fields'], <MasterLayoutRoute><CompanyDetails /></MasterLayoutRoute>, 'online_registration_form')} />
              <Route path="/event/registration/private-address-detail-form" element={this.menuRoute(['private_address_fields'], <MasterLayoutRoute><PrivateAddressForm /></MasterLayoutRoute>, 'online_registration_form')} />
              <Route path="/event/registration/attendee-type-form" element={this.menuRoute(['attendee_types'], <MasterLayoutRoute><AttendeeType /></MasterLayoutRoute>, 'online_registration_form')} />
              <Route path="/event/registration/custom-fields" element={this.menuRoute(['custom_fields'], <MasterLayoutRoute><CustomFields /></MasterLayoutRoute>, 'online_registration_form')} />
              <Route path="/event/registration/sub-registration" element={this.menuRoute(['sub_registrations'], <MasterLayoutRoute><SubRegistration /></MasterLayoutRoute>, 'online_registration_form')} />
              <Route path="/event/module/event-module-order" element={this.menuRoute(['customize_app_menus'], <MasterLayoutRoute><EventModuleOrder /></MasterLayoutRoute>)} />
              <Route path="/event/module/eventsite-module-order" element={this.menuRoute(['customize_website_menus'], <MasterLayoutRoute><EventSiteModuleOrder /></MasterLayoutRoute>)} />
              <Route path="/event/registration/manage/hotels" element={this.menuRoute(['accommodation'], <MasterLayoutRoute><HotelManagement /></MasterLayoutRoute>, 'online_registration_form')} />
              <Route path="/event/module/documents/:module?/:id?" element={this.menuRoute(['directory', 'ddirectory'], <MasterLayoutRoute><EventDocument /></MasterLayoutRoute>)} />

              {/*Event Modules Routes*/}
              {/*Registration Statistics Route - for testing event_id access*/}
              <Route path="/event_site/billing-module/registration_form/statsdashboard" element={<MasterLayoutRoute><RegistrationStatistics /></MasterLayoutRoute>} />
             
              <Route path="/event/module/attendees" element={this.menuRoute(['attendees'], <MasterLayoutRoute><AttendeeWidget /></MasterLayoutRoute>)} />
              <Route path="/event/module/attendees/import-logs" element={this.menuRoute(['attendees'], <MasterLayoutRoute><AttendeeImportLogs /></MasterLayoutRoute>)} />
              <Route path="/event/module/attendees/import-logs/:id" element={this.menuRoute(['attendees'], <MasterLayoutRoute><AttendeeImportLogDetail /></MasterLayoutRoute>)} />
              <Route path="/event/module/programs" element={this.menuRoute(['agendas'], <MasterLayoutRoute><ProgramWidget /></MasterLayoutRoute>)} />
              <Route path="/event/module/program/assign-speakers/:id" element={this.menuRoute(['agendas'], <MasterLayoutRoute><AssignProgramSpeaker /></MasterLayoutRoute>)} />
              <Route path="/event/module/speakers" element={this.menuRoute(['speakers'], <MasterLayoutRoute><SpeakerWidget /></MasterLayoutRoute>)} />
              <Route path="/event/module/teams" element={this.menuRoute(['team', 'teams'], <MasterLayoutRoute><TeamsWidget /></MasterLayoutRoute>)} />
              <Route path="/event/module/practical-information" element={this.menuRoute(['practical-info', 'infobooth'], <MasterLayoutRoute><PracticalInformation /></MasterLayoutRoute>)} />
              <Route path="/event/module/additional-information" element={this.menuRoute(['additional-info', 'additional_info'], <MasterLayoutRoute><AdditionalInformation /></MasterLayoutRoute>)} />
              <Route path="/event/module/general-information" element={this.menuRoute(['general-info', 'general_info'], <MasterLayoutRoute><GeneralInformation /></MasterLayoutRoute>)} />
              <Route path="/event/module/information-pages" element={this.menuRoute(['information_pages', 'information-pages'], <MasterLayoutRoute><InformationPages /></MasterLayoutRoute>)} />
              <Route path="/event/module/map" element={this.menuRoute(['maps'], <MasterLayoutRoute><GoogleMap /></MasterLayoutRoute>)} />
              <Route path="/event/module/sub-registration/results/:id" element={this.menuRoute(['subregistration', 'sub_registrations'], <MasterLayoutRoute><SubRegistrationResults /></MasterLayoutRoute>)} />
              <Route path="/event/module/sub-registration/:sub_registration_id/:attendee_id" element={this.menuRoute(['subregistration', 'sub_registrations'], <MasterLayoutRoute><SubRegistrationAttendeeEdit /></MasterLayoutRoute>)} />
              <Route path="/event/module/sub-registration" element={this.menuRoute(['subregistration', 'sub_registrations'], <MasterLayoutRoute><SubRegistration /></MasterLayoutRoute>)} />
              

              <Route path="/event/manage/surveys" element={this.menuRoute(['survey'], <MasterLayoutRoute><Survey /></MasterLayoutRoute>, 'survey')} />
              <Route path="/event/registration/tos" element={this.menuRoute(['terms_conditions'], <MasterLayoutRoute><Disclaimer /></MasterLayoutRoute>, 'online_registration_form')} />
              <Route path="/event/registration/gdpr" element={this.menuRoute(['gdpr_policy'], <MasterLayoutRoute><Gdprcontainer /></MasterLayoutRoute>, 'online_registration_form')} />
              <Route path="/event/manage/survey/questions/:id" element={<MasterLayoutRoute><SurveyQuestion /></MasterLayoutRoute>} />
              <Route path="/event/manage/survey/groups/:id" element={<MasterLayoutRoute><SurveyGroup /></MasterLayoutRoute>} />
              <Route path="/event/manage/survey/question/full-screen-projector/:event_id/:id" element={<SurveyQuestionFullScreenProjector />} />
              {/* <Route path="/event/manage/survey/groups/:id" element={<MasterLayoutRoute><SurveyGroups /></MasterLayoutRoute>} /> */}
              <Route path="/event/template/edit/:id?" element={<MasterLayoutRoute><TemplateEditor /></MasterLayoutRoute>} />
              <Route path="/event/template/logs/:id" element={<MasterLayoutRoute><TemplateLogs /></MasterLayoutRoute>} />
              <Route path="/event/template/history/view/:template_id/:id" element={<MasterLayoutRoute><ViewTemplateHistory /></MasterLayoutRoute>} />
              <Route path="/event/preview" element={<MasterLayoutRoute><AppPreview /></MasterLayoutRoute>} />
              <Route path="/event/invitation/report/registration" element={<MasterLayoutRoute><RegistrationInvitation /></MasterLayoutRoute>} />
              <Route path="/event/invitation/report/not-registered-attendees" element={<MasterLayoutRoute><NotRegisteredAttendees /></MasterLayoutRoute>} />
              <Route path="/event/invitation/report/not-attendees-list" element={<MasterLayoutRoute><NotAttendeesList /></MasterLayoutRoute>} />
              <Route path="/event/invitation/report/registration-reminder-log" element={<MasterLayoutRoute><RegistrationInvitationReminderLog /></MasterLayoutRoute>} />
              <Route path="/event/invitation/report/app-reminder-log" element={<MasterLayoutRoute><AppInvitationReminderLog /></MasterLayoutRoute>} />
              <Route path="/event/invitation/report/registration/settings" element={<MasterLayoutRoute><RegistrationInvitationSetting /></MasterLayoutRoute>} />
              <Route path="/event/invitation/report/app-invitation" element={<MasterLayoutRoute><AppInvitation /></MasterLayoutRoute>} />
              <Route path="/event/invitation/report/app-invitation-not-sent" element={<MasterLayoutRoute><AppInvitationNotSent /></MasterLayoutRoute>} />
              <Route path="/event/invitation/send-invitation/:step?" element={<MasterLayoutRoute><InvitationProcess /></MasterLayoutRoute>} />
              <Route path="/event/invitation/batch-status" element={<MasterLayoutRoute><InvitationBatchStatus /></MasterLayoutRoute>} />
              <Route path="/event/news/alerts" element={<EventFullScreenLayoutRoute><NewsWidget /></EventFullScreenLayoutRoute>} />
              <Route path="/event/reports" element={<EventFullScreenLayoutRoute><ReportWidget /></EventFullScreenLayoutRoute>} />

              <Route path="/event/registration/attendee-gdpr-log" element={this.menuRoute(['attendee_gdpr_logs'], <MasterLayoutRoute><AttendeeGdprLog /></MasterLayoutRoute>, 'online_registration_form')} />
              <Route path="/event/registration/add-attendee-to-registration" element={this.menuRoute(['add_attendee_to_registration'], <MasterLayoutRoute><RegistrationInvitesProcess /></MasterLayoutRoute>, 'online_registration_form')} />
              <Route path="/event/registration/add-attendee-to-registration/import-logs" element={this.menuRoute(['add_attendee_to_registration'], <MasterLayoutRoute><RegistrationInvitesImportLogs /></MasterLayoutRoute>, 'online_registration_form')} />
              <Route path="/event/registration/add-attendee-to-registration/import-logs/:id" element={this.menuRoute(['add_attendee_to_registration'], <MasterLayoutRoute><RegistrationInvitesImportLogDetail /></MasterLayoutRoute>, 'online_registration_form')} />
              {/*Eventsite Billing module*/}
              <Route path="/event_site/billing-module/custom-export" element={<MasterLayoutRoute><CustomExport /></MasterLayoutRoute>} />
              <Route path="/event_site/billing-module/payment-providers" element={<MasterLayoutRoute><PaymentProvider /></MasterLayoutRoute>} />
              <Route path="/event_site/billing-module/payment-methods" element={<MasterLayoutRoute><PaymentMethod /></MasterLayoutRoute>} />
              <Route path="/event_site/billing-module/ean-invoice" element={<MasterLayoutRoute><EANInvoiceSetting /></MasterLayoutRoute>} />
              <Route path="/event_site/billing-module/fik-setting" element={<MasterLayoutRoute><FIKSetting /></MasterLayoutRoute>} />
              <Route path="/event_site/billing-module/items" element={<MasterLayoutRoute><BillingItem /></MasterLayoutRoute>} />
              <Route path="/event_site/billing-module/waiting-list-orders" element={<MasterLayoutRoute><WaitingListOrders /></MasterLayoutRoute>} />
              <Route path="/event_site/billing-module/purchase-policy" element={<MasterLayoutRoute><PurchasePolicy /></MasterLayoutRoute>} />
              <Route path="/event_site/billing-module/voucher" element={<MasterLayoutRoute><Voucher /></MasterLayoutRoute>} />
              <Route path="/event_site/billing-module/manage-orders" element={<MasterLayoutRoute><Order /></MasterLayoutRoute>} />
              <Route path="/event_site/billing-module/registration_form/statsdashboard" element={<MasterLayoutRoute><RegistrationStatistics /></MasterLayoutRoute>} />
              <Route path="/event_site/billing-module/order-summary/:id" element={<MasterLayoutRoute><OrderSummary /></MasterLayoutRoute>} />

              <Route path="/event/manage/survey/leaderboard/:event_id/:survey_id" element={<SurveyLeaderBoard />} />
              
              {/*Organizer routes*/}
              <Route path="/account/organizer/profile" element={<MasterLayoutRoute><Profile /></MasterLayoutRoute>} />
              <Route path="/account/organizer/change-password" element={<MasterLayoutRoute><Password /></MasterLayoutRoute>} />
              <Route path="/organizer-email-history" element={<DashboardLayoutRoute><OrganizerEmailHistory /></DashboardLayoutRoute>} />
              <Route path="/event/module/news" element={this.menuRoute(['news'], <MasterLayoutRoute><EventsiteNewsWidget /></MasterLayoutRoute>)} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

export default connect(mapStateToProps)(RouterOutlet);
